export function formatNumberWithSign(number, prefix = false) {
    if (typeof number !== 'number' || isNaN(number)) return '-';
    const sign = number >= 0 ? '+' : '-';
    const formattedNumber = new Intl.NumberFormat().format(Math.abs(number));
    return prefix ? sign + formattedNumber : formattedNumber;
}
